import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import EventNoteIcon from "@mui/icons-material/EventNote";
import FileDownloadDoneIcon from "@mui/icons-material/FileDownloadDone";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import SyncIcon from "@mui/icons-material/Sync";
import { Theme } from "@mui/material";
import { ClientModelExecutionStatus } from "@services/api/types";

const executionStatusIconMapping: Record<
  ClientModelExecutionStatus,
  React.ReactNode
> = {
  SUBMITTED: <EventNoteIcon />,
  PENDING: <PendingActionsIcon />,
  RUNNING: <SyncIcon />,
  SUCCEEDED: <FileDownloadDoneIcon />,
  FAILED: <ErrorOutlineIcon />
};

export const getExecutionStatusIcon = (status: string) => {
  return (
    executionStatusIconMapping[status as ClientModelExecutionStatus] || (
      <PendingActionsIcon />
    )
  );
};

export const getExecutionStatusColor = (status: string, theme: Theme) => {
  const executionStatusColorMapping: Record<
    ClientModelExecutionStatus,
    string
  > = {
    SUBMITTED: theme.palette.primary.main,
    PENDING: theme.palette.warning.main,
    RUNNING: theme.palette.info.main,
    SUCCEEDED: theme.palette.success.main,
    FAILED: theme.palette.error.main
  };

  return (
    executionStatusColorMapping[status as ClientModelExecutionStatus] ||
    theme.palette.primary.main
  );
};

export interface Column {
  id: "name" | "year" | "aggregation_type" | "execution_status";
  label: string;
  minWidth?: number;
  align?: "left" | "center" | "right";
  format?: (value: number) => string;
}

export const columns: readonly Column[] = [
  { id: "name", label: "name", minWidth: 150, align: "center" },
  { id: "year", label: "year", minWidth: 150, align: "center" },
  {
    id: "aggregation_type",
    label: "aggregation_type",
    minWidth: 150,
    align: "center"
  },

  {
    id: "execution_status",
    label: "execution_status",
    minWidth: 150,
    align: "center"
  }
];
